__turbopack_context__.v({
  "align-center": "headline-module-scss-module__8hKrjG__align-center",
  "align-left": "headline-module-scss-module__8hKrjG__align-left",
  "align-right": "headline-module-scss-module__8hKrjG__align-right",
  "headline-l": "headline-module-scss-module__8hKrjG__headline-l",
  "headline-m": "headline-module-scss-module__8hKrjG__headline-m",
  "headline-s": "headline-module-scss-module__8hKrjG__headline-s",
});
